var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "descriptionContainer", attrs: { id: "bundleDetail" } },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-block text-left descriptionButton",
          class: { collapsed: !_vm.isOpen },
          attrs: {
            "aria-expanded": _vm.isOpen ? "true" : "false",
            "aria-controls": "bundleComponents",
            "aria-label": "Paketbestandteile anzeigen",
            "click-count": "",
          },
          on: { click: _vm.toggleBundleComponents },
        },
        [
          _c(
            "svg",
            {
              staticClass: "icon-bundle",
              attrs: {
                viewBox: "0 0 24 24",
                width: "22",
                height: "22",
                stroke: "currentColor",
                "stroke-width": "1.5",
                fill: "none",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            },
            [
              _c("line", {
                attrs: { x1: "16.5", y1: "9.4", x2: "7.5", y2: "4.21" },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
                },
              }),
              _vm._v(" "),
              _c("polyline", {
                attrs: { points: "3.27 6.96 12 12.01 20.73 6.96" },
              }),
              _vm._v(" "),
              _c("line", {
                attrs: { x1: "12", y1: "22.08", x2: "12", y2: "12" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("In diesem Set enthalten")]),
          _vm._v(" "),
          _c("i", { attrs: { "data-feather": "plus" } }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "collapse mt-1",
          class: { show: _vm.isOpen },
          attrs: {
            id: "bundleComponents",
            "aria-labelledby": "bundleComponents",
            "data-parent": "#rightSide",
          },
        },
        [
          _vm.isLoading
            ? _c("loading-animation")
            : _vm.loadFailed
            ? _c("div", { staticClass: "descriptionContent" }, [
                _vm._v(
                  "\n            Paketbestandteile konnten nicht geladen werden.\n        "
                ),
              ])
            : _vm.bundleComponents.length === 0
            ? _c("div", { staticClass: "descriptionContent" }, [
                _vm._v(
                  "\n            Keine Paketbestandteile vorhanden.\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.visibleBundleComponents, function (bundleComponent) {
            return _c(
              "div",
              {
                key: _vm.getBundleComponentKey(bundleComponent),
                staticClass: "bundleComponentItem",
              },
              [
                _c("category-item", {
                  attrs: {
                    "item-bundle-quantity": bundleComponent.quantity,
                    "item-data": bundleComponent.data,
                    "view-mode": "cart",
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }